import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../scripts/control';


const BdMovieDetail = () => {
    const { idMovie } = useParams();
    const { idMovieTag } = useParams();
    const navigate = useNavigate();
    const [movie, setMovie] = useState(null);
    const [tag, setTag] = useState(null);
    const [selectedTag, setSelectedTag] = useState(null); 
    const [tagDetails, setTagDetails] = useState(null); 
    const [showModal, setShowModal] = useState(false); 

    useEffect(() => {
        const fetchMovies = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php?idMovie=${idMovie}`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
    
                // Asegurar que data.tags sea un array
                const tags = Array.isArray(data.tags) ? data.tags : [];
    
                // Asegurarse de que data.movies existe y es un array
                const movies = data.movies || [];
                const foundMovie = movies[0] || null;
    
                if (foundMovie) {
                    // Convertir foundMovie.tags a un array si es un string
                    if (typeof foundMovie.tags === 'string') {
                        foundMovie.tags = foundMovie.tags
                            .split(', ')
                            .map(tag => tag.trim());
                    } else if (!Array.isArray(foundMovie.tags)) {
                        foundMovie.tags = [];
                    }
    
                    // Construir un objeto para los detalles de etiquetas usando los id y nombres de tags
                    const tagDetailsByName = {};
                    tags.forEach(tag => {
                        if (foundMovie.tagsDetails && foundMovie.tagsDetails[tag.idTag]) {
                            tagDetailsByName[tag.tagName] = foundMovie.tagsDetails[tag.idTag];
                        }
                    });
    
                    foundMovie.tagsDetails = tagDetailsByName;
                    setMovie(foundMovie);
                } else {
                    setMovie(null);
                }
            } catch (error) {
                console.error('Error al cargar las películas:', error);
                setMovie(null);
            }
        };
    
        fetchMovies();
    }, [idMovie]);


    useEffect(() => {
    const fetchTags = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php?fetchTags=true`);
                const data = await response.json();
                const tags = Array.isArray(data.tags) ? data.tags : [];
            
                // Filtrar la película específica por `idMovieTag` en el frontend
                const foundTag = tags.find(tag => tag.idTag === idMovieTag); 
            
            setTag(foundTag || null);
            } catch (error) {
                console.error('Error al cargar las etiquetas:', error);
            }
        };
        fetchTags();
    }, [idMovieTag]);

    const handleTagClick = (clickedTag) => {
        // Obtener los detalles de la etiqueta desde el objeto tagsDetails
        const tagDetail = movie.tagsDetails[clickedTag] || "No hay detalles disponibles para esta etiqueta.";
    
        setSelectedTag(clickedTag);
        setTagDetails(tagDetail);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setTagDetails(null);
    };

    if (!movie) {
        return <div>Cargando detalles...</div>;
    }
    
    return (
        <div className="container">
            <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
                Volver
            </button>
            <div className="card">
                <img
                    src={`${API_BASE_URL}/public/uploads/images/${movie.img_url}`}
                    alt={movie.movieName}
                    className="card-img-top"
                />
                <div className="card-body">
                    <h2>{movie.movieName}</h2>
                    <p><strong>Año:</strong> {movie.movieYear}</p>
                    <p><strong>Clasificación:</strong> {movie.movieAge}</p>
                    <p><strong>Duración:</strong> {movie.movieDuration} minutos</p>
                    <p><strong>Etiquetas:</strong></p>
                    <div>
                        {movie.tags?.map((tag, index) => (
                        <button
                            key={index}
                            className="btn btn-outline-primary me-2 mb-2"
                            onClick={() => handleTagClick(tag)}
                        >
                            {tag}
                        </button>
                    ))}
                    </div>
                </div>
            </div>
    
            {/* Modal */}
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{selectedTag} en {movie.movieName}</h5>
                                <button type="button" className="btn-close" onClick={closeModal}></button>
                            </div>
                            <div className="modal-body">
                                {tagDetails ? (
                                    <p>{tagDetails}</p>
                                ) : (
                                    <p>Cargando detalles de la etiqueta...</p>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BdMovieDetail;
